import { render, staticRenderFns } from "./RtaRequestFields.vue?vue&type=template&id=722987f0&scoped=true"
import script from "./RtaRequestFields.vue?vue&type=script&lang=js"
export * from "./RtaRequestFields.vue?vue&type=script&lang=js"
import style0 from "./RtaRequestFields.vue?vue&type=style&index=0&id=722987f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722987f0",
  null
  
)

export default component.exports